import React from 'react';

import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';

import { useSendSideNavItemClick } from '@townsquare/analytics-nav4';
import type { CommonSideNavItemWithPathProps, DefaultItemType } from '@townsquare/griffin-navigation/types';
import { useRouter } from '@townsquare/router/useRouter';

/**
 * Generic nav item component that handles external redirect when path contains cloudId query param. This means the item is in a different site in the unit.
 * Used for items that may need to redirect to a different site in the unit.
 */
export const ExternalRedirectNavItem = ({
	onClick,
	isSelected,
	item,
}: CommonSideNavItemWithPathProps & { item: DefaultItemType }): React.JSX.Element => {
	const sendSideNavItemClick = useSendSideNavItemClick();
	const [routerStore] = useRouter();

	// If path contains cloudId query param, it means we need to redirect to a different site
	const needsExternalRedirect = item.path.includes('cloudId=');

	const handleClickForExternalRedirect = (e: React.MouseEvent<Element> | React.KeyboardEvent<Element>) => {
		e.preventDefault();
		sendSideNavItemClick('navigationItem', item.analyticsSubject, { screen: routerStore.route.name });
		window.open(item.path, e.metaKey ? '_blank' : '_self', 'noopener noreferrer');
	};

	const onClickHandler = (e: React.MouseEvent<Element> | React.KeyboardEvent<Element>) => {
		if (needsExternalRedirect) {
			handleClickForExternalRedirect(e);
		} else {
			onClick(item, e);
		}
	};

	return (
		<LinkMenuItem
			isSelected={isSelected}
			elemBefore={<item.Icon label="" />}
			href={item.path}
			testId={item.testId}
			onClick={onClickHandler}
		>
			{item.name}
		</LinkMenuItem>
	);
};
